import dayjs from 'dayjs';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CopyOutlined, EyeOutlined } from '@ant-design/icons';

import { simpleToast } from '../utils/toastUtils.js';
import * as utils from '../utils/utils.js';

import 'dayjs/locale/is.js';

export default function PastSessionItemAdmin({ session }) {
    const navigate = useNavigate();

    function copyToClipboard() {
        navigator.clipboard.writeText(
            window.location.origin + '/session/event/' + session.event_id
        );
        simpleToast('Copied to clipboard 📋');
    }

    return (
        <tr
            style={{
                borderBottom: '1px solid #e8e8e8',
                transition: 'background-color 0.2s',
                cursor: 'pointer'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            onClick={() => navigate('/session/' + session.session_id)}
        >
            <td style={{ padding: '6px 12px', verticalAlign: 'middle' }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    fontSize: '12px',
                    color: '#1f2937'
                }}>
                    <span style={{ fontWeight: '500', minWidth: '100px' }}>
                        {utils.dateMaybeWithYear(session.timestamp, 'en')} {dayjs(session.timestamp).format('HH:mm')}
                    </span>
                    <span style={{ fontWeight: '500' }}>
                        {session.event.name}
                    </span>
                    {(session.event.short_description || session.event.venue) && (
                        <span style={{ color: '#6b7280', fontWeight: 'normal' }}>
                            {session.event.short_description && (
                                <span>{session.event.short_description}</span>
                            )}
                            {session.event.short_description && session.event.venue && (
                                <span> • </span>
                            )}
                            {session.event.venue && (
                                <span>{session.event.venue}</span>
                            )}
                        </span>
                    )}
                </div>
            </td>
            <td style={{ padding: '6px 12px', verticalAlign: 'middle', textAlign: 'right', width: '120px' }}>
                <div style={{ display: 'flex', gap: '6px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate('/session/' + session.session_id);
                        }}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '4px 10px',
                            fontSize: '11px',
                            fontWeight: '500',
                            backgroundColor: 'white',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#f3f4f6';
                            e.currentTarget.style.borderColor = '#9ca3af';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'white';
                            e.currentTarget.style.borderColor = '#d1d5db';
                        }}
                    >
                        <EyeOutlined style={{ fontSize: '12px' }} />
                        View
                    </button>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            copyToClipboard();
                        }}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '4px 10px',
                            fontSize: '11px',
                            fontWeight: '500',
                            backgroundColor: 'white',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#f3f4f6';
                            e.currentTarget.style.borderColor = '#9ca3af';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'white';
                            e.currentTarget.style.borderColor = '#d1d5db';
                        }}
                        title="Copy link to clipboard"
                    >
                        <CopyOutlined style={{ fontSize: '12px' }} />
                        Copy
                    </button>
                </div>
            </td>
        </tr>
    );
}
